import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { BlogType } from "src/shared/config";

import { initialState } from "../config/constants";

import { createBlog, getBlogs } from "./blogsSlice.thunks";

const blogsSlice = createSlice({
  name: "blogs",
  initialState,
  reducers: {
    changeNewBlog: (state, action: PayloadAction<Partial<BlogType>>) => {
      state.newBlog = { ...state.newBlog, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getBlogs.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });
    builder.addCase(getBlogs.pending, (state) => {
      state.error = "";
      state.isLoading = true;
    });
    builder.addCase(
      getBlogs.fulfilled,
      (state, action: PayloadAction<BlogType[]>) => {
        state.blogs = action.payload;
        state.error = "";
        state.isLoading = false;
      },
    );

    builder.addCase(createBlog.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });
    builder.addCase(createBlog.pending, (state) => {
      state.error = "";
      state.isLoading = true;
    });
    builder.addCase(
      createBlog.fulfilled,
      (state, action: PayloadAction<BlogType>) => {
        state.blogs = [...state.blogs, action.payload];
        state.error = "";
        state.isLoading = false;
      },
    );
  },
});

export const { actions } = blogsSlice;

export default blogsSlice.reducer;
